<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Notaris</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-balance-scale" />
            Notaris
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5 text-right mt-2">
        <CButton color="success" @click="$router.push('/contract')" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
          Assign Kontrak
        </CButton>
        <CButton color="primary" class="ml-2" @click="$router.push('/notaris/create')">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="col-xs-10 col-sm-8 col-md-7 col-lg-6 col-xl-5 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.value" 
                    :options="filter.options"
                    :searchable="false"
                    id="filter-table-notary"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.value" :options="filter.options" @change="clearFilterValue"></b-form-select>
                </b-input-group-prepend>
                <b-form-select v-if="filter.value == 'status'" v-model="filter.filterSearch" :options="filter.optionsStatus"></b-form-select>
                <b-form-input v-else maxlength="50" v-model="filter.filterSearch" autocomplete="off" placeholder="Search"></b-form-input>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel Notaris" :disabled="!notaryTable.isLoaded" @click="filterNotaryTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="notaryTable.items"
              :fields="notaryTable.fields"
              :busy="!notaryTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onNotaryTableSortChanged"
            >
              <template #cell(id)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(name)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(status)="row">
                  <CBadge v-if="row.value == 'AC'" color="success"> AKTIF
                  </CBadge>
                  <CBadge v-else color="danger"> NONAKTIF
                  </CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="warning" title="Edit Notaris" class="btn-icon mr-1 custom-button-action custom-button-white" @click="$router.push({ name: 'Notaris Edit', params: { notarisId: row.item.id } })">
                  <b-icon icon="pencil-square"></b-icon>
                </CButton>
                <CButton size="sm" color="danger" class="custom-button-action" style="width:5.5rem" @click="toggleStatus(row.index)" :disabled="row.item.isToggling" v-if="row.item.status == 'AC'">
                  <b-spinner small v-if="row.item.isToggling" />
                  <span v-else>Deaktivasi</span>
                </CButton>
                <CButton size="sm" color="success" class="custom-button-action" style="width:5.5rem" @click="toggleStatus(row.index)" :disabled="row.item.isToggling" v-else>
                  <b-spinner small v-if="row.item.isToggling" />
                  <span v-else>Aktivasi</span>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!notaryTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="notaryTable.totalRows" :page="notaryTable.currentPage" @limit-change="onNotaryTableLimitChange" @page-change="onNotaryTablePageChange" />
              <!-- <PageSizer :totalRows="notaryTable.totalRows" :page="notaryTable.currentPage" :options="tablePageOptions" @limit-change="onNotaryTableLimitChange" @page-change="onNotaryTablePageChange" /> -->
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CContainer>
</template>


<script>
export default {
  name: 'NotarisList',
  data() {
    return {
      /*
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      */
      filter: {
        value: "id",
        options: [
          { value:"id", text: "ID Notaris" },
          { value:"name", text: "Nama Notaris" },
          // { value:"officeName", text: "Area" },
          { value:"status", text: "Status Notaris" }
        ],
        optionsStatus: [
          { value:"ac", text: "Aktif" },
          { value:"na", text:"Nonaktif" }
        ],
        filterSearch: '',
        filterType: '',
        filterValue: ''
      },
      notaryTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "id", label: "ID Notaris", sortable: true},
          {key: "name", label: "Nama Notaris", sortable: true},
          // {key: "officeName", label: "Area", sortable: true},
          {key: "status", label: "Status Notaris", sortable: true},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-notary" }
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {
    // update table with server-side processing on change
    onNotaryTableLimitChange(newPerPage) {
      this.notaryTable.perPage = newPerPage
      // only fetch data when roles apply
      this.getNotaryTableItems()
    },
    onNotaryTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getNotaryTableItems(newPage)
    },
    onNotaryTableSortChanged(ctx) {
      this.notaryTable.sortBy = ctx.sortBy
      this.notaryTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getNotaryTableItems(this.notaryTable.currentPage)
    },
    clearFilterValue() {
      this.filter.filterSearch = ''
      this.filter.filterType = ''
      this.filter.filterValue = ''
      if (this.filter.value == 'status') {
        this.filter.filterSearch = 'ac'
      }
    },
    toggleStatus(idx) {
      let postUrl = "/notary/toggleStatus"
      let payload = new FormData()
      payload.append("id", this.notaryTable.items[idx].id)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        // use index to properly update table row after manipulation
        this.notaryTable.items[idx].isToggling = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            if(this.notaryTable.items[idx].status == "AC") this.notaryTable.items[idx].status = "NA"
            else this.notaryTable.items[idx].status = "AC"
            this.$helper.toastSuccess(this, (this.notaryTable.items[idx].status == "AC" ? "Aktivasi" : "Deaktivasi") + " Notaris Berhasil! " + (response.data.reason ? response.data.reason : ""))
          }
          else{
            this.$helper.toastError(this, "Ubah Status Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Ubah Status Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Ubah Status Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.notaryTable.items[idx].isToggling = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    filterNotaryTable(event){
      event.preventDefault()
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getNotaryTableItems()
    },
    // get paginated table contents from server-side
    getNotaryTableItems(page = 1) {
      if(isNaN(page)) {
        this.notaryTable.currentPage = 1
      }
      else {
        this.notaryTable.currentPage = page
      }
      // URL builder
      let getUrl = "/notary/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.notaryTable.currentPage - 1, this.notaryTable.perPage)
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.notaryTable.sortBy != null) {
        params['sortBy'] = this.notaryTable.sortBy
        params['asc'] = !this.notaryTable.sortDesc
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.notaryTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            sessionStorage.setItem("filterNotarisType", this.filter.filterType)
            sessionStorage.setItem("filterNotarisValue", this.filter.filterValue)
            this.notaryTable.items = response.data.data.data.map(item => {
              return {
                "id": item.id,
                "name": item.name,
                // "officeName": item.officeName,
                "status": item.status,
                "isToggling": false
              }
            })
            this.notaryTable.totalRows = response.data.data.totalElements
            this.notaryTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.notaryTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterNotarisType"))){
      this.filter.filterType = sessionStorage.getItem("filterNotarisType")
      this.filter.value = sessionStorage.getItem("filterNotarisType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterNotarisValue"))){
      this.filter.filterValue = sessionStorage.getItem("filterNotarisValue")
      this.filter.filterSearch = sessionStorage.getItem("filterNotarisValue")
    }
    // get table contents on page load
    this.getNotaryTableItems()
  },
  created() {
  }
}
</script>

<style>

</style>
